import React, { useState } from 'react';
import { Box, Line } from '@react-three/drei';
import * as THREE from 'three';

const CanvasButton = ({ position, rotation, wallId, onAddSpot, isShowMode }) => {
  const [hovered, setHovered] = useState(false);

  // Don't render in show mode
  if (isShowMode) return null;

  const handleClick = (event) => {
    event.stopPropagation();
    if (onAddSpot) {
      // Convert rotation array to Euler for calculations
      const euler = new THREE.Euler(...rotation);
      
      // Create a forward vector (direction the button is facing)
      const forwardVector = new THREE.Vector3(0, 0, 1).applyEuler(euler);
      
      // Place canvas just a tiny bit closer to wall than button
      const spotPosition = [
        position[0] - forwardVector.x * 0.03,
        position[1],
        position[2] - forwardVector.z * 0.03
      ];

      onAddSpot({
        wallId,
        position: spotPosition,
        rotation: rotation,
        surfaceNormal: [forwardVector.x, forwardVector.y, forwardVector.z]
      });
    }
  };

  // Colors
  const baseColor = "#333333";  // Lighter base color
  const hoverColor = "#666666";  // Lighter hover color
  const plusColor = "#ffffff";   // White for the plus symbol

  // Plus symbol size and thickness
  const plusSize = 0.2;
  const plusThickness = 3;

  // Visual offset from wall (doesn't affect spot placement)
  const visualOffset = 0.05;  // Just barely off the wall surface

  return (
    <group
      position={position}
      rotation={rotation}
      onClick={handleClick}
      onPointerOver={(e) => {
        e.stopPropagation();
        document.body.style.cursor = 'pointer';
        setHovered(true);
      }}
      onPointerOut={(e) => {
        e.stopPropagation();
        document.body.style.cursor = 'default';
        setHovered(false);
      }}
    >
      {/* Main button box - moved forward visually */}
      <Box args={[0.6, 0.6, 0.1]} position={[0, 0, visualOffset]}>
        <meshStandardMaterial 
          color={hovered ? hoverColor : baseColor}
          metalness={0.4}
          roughness={0.5}
          emissive={hovered ? hoverColor : baseColor}
          emissiveIntensity={hovered ? 0.5 : 0.2}
        />
      </Box>

      {/* Plus symbol - on top of the box */}
      <group position={[0, 0, visualOffset + 0.051]}>
        {/* Vertical line */}
        <Line
          points={[[0, plusSize, 0], [0, -plusSize, 0]]}
          color={plusColor}
          lineWidth={plusThickness}
          transparent
          opacity={1}
        />
        {/* Horizontal line */}
        <Line
          points={[[-plusSize, 0, 0], [plusSize, 0, 0]]}
          color={plusColor}
          lineWidth={plusThickness}
          transparent
          opacity={1}
        />
      </group>
    </group>
  );
};

export default CanvasButton; 